const communicationValues = [
  { value: 'Email', label: 'Email' },
  { value: 'SMS', label: 'SMS' }
];

export default communicationValues;
